import React from 'react';
import { Accordion, Chip } from '@weezevent/nacre';
import EmptyCart from './EmptyCart';
import css from './modal-summary.module.css';
import SummaryAttendee from './SummaryAttendee';

export default function SummaryItem({
    inventory,
    selectedZone,
    categories,
    attendees = [],
    onChange,
    previousZone,
    currentInventory,
    onChangeAllForm,
    availability,
    sync,
    form,
    onAddAttendee,
    unbookBooking = () => {}
}) {
    const renderAttendeeCard = React.useMemo(() => {
        if (!attendees.length) {
            return <EmptyCart />;
        }

        return attendees.map((attendee, index) => {
            return (
                <SummaryAttendee
                    key={attendee.id}
                    availability={availability}
                    sync={sync}
                    attendee={attendee}
                    form={form}
                    previousZone={previousZone}
                    onChangeAllForm={onChangeAllForm}
                    selectedZone={selectedZone}
                    categories={categories}
                    currentInventory={currentInventory}
                    onChangeForm={onChange}
                    index={index}
                    unbookBooking={unbookBooking}
                    onAddAttendee={onAddAttendee}
                />
            );
        });
    }, [attendees, unbookBooking]);

    let counter = React.useMemo(() => {
        return attendees.length;
    }, [attendees]);

    const actualInventory = React.useMemo(() => {
        return currentInventory === inventory.uuid;
    }, [currentInventory, inventory]);

    return (
        <Accordion
            openByDefault={actualInventory}
            title={
                <div className={css['summary-item-title']}>
                    <span>{inventory.name}</span>
                    <div className={css['summary-item-counter']}>{counter > 0 && <Chip className={css['summary-counter-chip']} primary icon="user" text={`x${counter}`} />}</div>
                </div>
            }
        >
            {renderAttendeeCard}
        </Accordion>
    );
}
